import axiosClient from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import { getQueryString } from "utilities/common";

export async function getTraitsListingAPI(data) {
    const query = { ...data };
    if (query.platformType == null) query.platformType = '';
    return await axiosClient.get(`/api/v1/product/traits/main/listing?${getQueryString(query)}`);
}

export async function createMainTraitAPI(data){
    return await axiosClient.post('/api/v1/product/traits/main/create', data);
}

export async function deleteMainTraitAPI(slug, platform){
    return await axiosHyperwolfClient.delete(`/api/v1/product/main/delete/${slug}?platformType=${platform}`)
}

export async function getTraitByIdAPI(slug, data){
    return await axiosClient.get(`/api/v1/product/traits/main/${slug}?${getQueryString(data)}`)
}

export async function updateMainTraitAPI(data,slug,platform){
    // return await axiosClient.put(`/api/v1/product/traits/main/update/${slug}`, data)
    return await axiosHyperwolfClient.put(`/api/v1/product/trait/main/update/${slug}`, data)

}

export async function getUnitListingAPI() {
    return await axiosClient.get('/api/v1/product/unit/listing');
}

export async function createProductUnitsAPI(data){
    return await axiosClient.post('/api/v1/create/product/unit', data);
}

export async function deleteProductUnitsAPI(unit) {
    // Encode the unit to safely handle special characters like '%'
    const encodedUnit = encodeURIComponent(encodeURIComponent(unit));
    
    // Perform the delete request with the encoded unit
    return await axiosClient.delete(`/api/v1/delete/product/unit/${encodedUnit}`);
}

export async function createProductTraitAPI(data) {
    return await axiosClient.post('api/v1/product/traits/assignment',data)
}

export async function deleteProductTraitAPI(productId,productTraitId) {
    return await axiosClient.delete(`api/v1/product/traits/delete/${productId}/${productTraitId}`)
}